/**
 *  @class
 *  @function FreeShipping
 *  Amount-only condition: cart total >= threshold.
 *  (The former "2+ nail sets" quantity track was removed with that promotion.)
 */
if (!customElements.get('free-shipping')) {
  // The cart re-renders as fresh HTML, so the offer tiers would jump to their new
  // widths. Remember the last widths per block and slide from them instead.
  var offerFills = {};
  var slideOfferTiers = function (el) {
    var offer = el.closest('.joyee-offer');
    var fills = offer ? offer.querySelectorAll('.joyee-offer__fill') : [];
    if (!fills.length) return; // still being parsed; recorded on DOMContentLoaded
    var key = el.closest('#Cart-Drawer') ? 'drawer' : 'page';
    var now = Array.prototype.map.call(fills, function (f) { return f.style.width; });
    var last = offerFills[key];
    offerFills[key] = now;
    if (!last || last.join() === now.join()) return;
    fills.forEach(function (f, i) { f.style.width = last[i]; });
    offer.offsetWidth; // commit the old widths so the change below transitions
    fills.forEach(function (f, i) { f.style.width = now[i]; });
  };
  // The code didn't go on (no reply, or it can't apply to this cart): free the button and say so.
  var showCodeError = function () {
    document.querySelectorAll('.joyee-offer__code.is-busy').forEach(function (b) { b.classList.remove('is-busy'); });
    document.querySelectorAll('.joyee-offer__error').forEach(function (p) { p.hidden = false; });
  };
  var celebrate = function (btn) {
    btn.classList.add('is-celebrate');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#c4603a', '#e9c9b8', '#f2b705', '#2f7d4f', '#fff'];
    for (var i = 0; i < 14; i++) {
      var spark = document.createElement('span'), a = (Math.PI * 2 * i) / 14, r = 34 + Math.random() * 22;
      spark.className = 'joyee-offer__spark';
      spark.style.background = colors[i % colors.length];
      spark.style.setProperty('--dx', Math.cos(a) * r * 1.6 + 'px');
      spark.style.setProperty('--dy', Math.sin(a) * r + 'px');
      btn.appendChild(spark);
      setTimeout(spark.remove.bind(spark), 800);
    }
  };
  // The cart re-renders as fresh HTML, which closed the gift steps mid-read: remember whether they were open.
  var giftHowOpen = false;
  document.addEventListener('toggle', function (e) {
    if (e.target.classList && e.target.classList.contains('joyee-gift__more')) giftHowOpen = e.target.open;
  }, true);
  // Phone drawer "Details": same reason, the choice has to survive the redraw.
  var giftDetailsOpen = false;
  var showDetails = function (offer) {
    offer.classList.toggle('is-open', giftDetailsOpen);
    var t = offer.querySelector('.joyee-offer__toggle');
    if (t) t.setAttribute('aria-expanded', giftDetailsOpen);
  };
  // Gift tiers (free-shipping.liquid): thresholds are USD cents, converted like the free-shipping minimum.
  // The track is drawn in thirds, one node over each amount: 0 → $59 → $109 → $149.
  var giftTiers = function (el) {
    var offer = el.closest('.joyee-offer');
    var msg = offer && offer.querySelector('[data-gift-msg]');
    if (!msg) return;
    var total = parseInt(el.dataset.giftTotal, 10), rate = Shopify.currency.rate || 1;
    var fmt = window.theme.settings.money_with_currency_format || '${{amount}}';
    var short = fmt.replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
    var stops = offer.querySelectorAll('[data-gift-min]');
    var mins = Array.prototype.map.call(stops, function (c) { return Math.round(parseInt(c.dataset.giftMin, 10) * rate); });
    var level = mins.filter(function (m) { return total >= m; }).length;
    var pos = [100 / 6, 50, 500 / 6], fill = 100;
    if (level === 0) fill = pos[0] * total / mins[0];
    else if (level < mins.length) fill = pos[level - 1] + (pos[level] - pos[level - 1]) * (total - mins[level - 1]) / (mins[level] - mins[level - 1]);
    offer.querySelector('.joyee-gift__fill').style.width = Math.min(100, fill) + '%';
    offer.querySelectorAll('.joyee-gift__track i').forEach(function (n, i) { n.classList.toggle('is-on', i < level); });
    stops.forEach(function (c, i) {
      c.querySelector('.joyee-gift__amt').innerHTML = formatMoney(mins[i], short);
      c.classList.toggle('is-unlocked', i < level);
    });
    var left = formatMoney(level < mins.length ? mins[level] - total : 0, fmt);
    msg.innerHTML = msg.dataset['t' + level].replace('[amount]', '<b>' + left + '</b>');
    var dec = offer.querySelector('[data-gift-dec]');
    dec.classList.toggle('is-on', level > 0);
    dec.querySelector('[data-gift-title]').textContent = dec.dataset['g' + level];
    dec.querySelector('[data-gift-note]').innerHTML = dec.dataset['n' + level].replace('[amount]', left);
    var more = offer.querySelector('.joyee-gift__more');
    if (more && giftHowOpen) more.open = true;
    showDetails(offer);
    var step = offer.querySelector('[data-gift-step]');
    var buy = parseInt(stops[Math.max(level, 1) - 1].dataset.giftBuy, 10);
    step.innerHTML = step.dataset.s.replace('[amount]', formatMoney(Math.round(buy * rate), short));
  };
  // Same request and re-render as cart-discounts.js, keeping any other code already in the cart.
  document.addEventListener('click', function (e) {
    var details = e.target.closest('.joyee-offer__toggle');
    if (details) {
      giftDetailsOpen = !giftDetailsOpen;
      showDetails(details.closest('.joyee-offer'));
      return;
    }
    var btn = e.target.closest('.joyee-offer__code');
    if (!btn || btn.classList.contains('is-busy')) return;
    var code = btn.dataset.code;
    var on = btn.closest('.joyee-offer').classList.contains('is-code-on');
    var scope = btn.closest('#Cart-Drawer, #Cart') || document;
    var codes = Array.prototype.map.call(scope.querySelectorAll('.cart-discounts--name'), function (p) { return p.textContent.trim(); })
      .filter(function (c) { return c.toUpperCase() !== code; });
    if (!on) codes.push(code);
    var sections = [['Cart', 'main-cart', '.thb-cart-form'], ['Cart-Drawer', 'cart-drawer', '.cart-drawer'], ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']];
    btn.classList.add('is-busy');
    fetch(theme.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: sections.map(function (s) { return s[1]; }), sections_url: window.location.pathname })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        var mine = (state.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        sections.forEach(function (s) {
          var host = document.getElementById(s[0]);
          var target = host && (host.querySelector(s[2]) || host);
          var html = state.sections && state.sections[s[1]];
          if (target && html) target.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector(s[2]).innerHTML;
        });
        if (!state.sections || (!on && !(mine && mine.applicable))) showCodeError();
        else if (mine && mine.applicable) document.querySelectorAll('.joyee-offer__code.is-applied').forEach(celebrate);
      })
      .catch(showCodeError);
  });
  class FreeShipping extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      var total = parseInt(this.dataset.cartTotal, 10);
      var minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));

      var amountPct = Math.min(total / minimum, 1);
      var met = amountPct >= 1;

      var remainingEl = this.querySelector('.free-shipping--text-remaining');
      var fullEl = this.querySelector('.free-shipping--text-full');

      if (met) {
        if (remainingEl) remainingEl.style.display = 'none';
        if (fullEl) fullEl.style.display = 'block';
      } else {
        if (remainingEl) {
          remainingEl.style.display = 'block';
          var span = remainingEl.querySelector('span');
          if (span) {
            var format = window.theme.settings.money_with_currency_format || "${{amount}}";
            span.innerHTML = formatMoney(minimum - total, format);
          }
        }
        if (fullEl) fullEl.style.display = 'none';
      }

      giftTiers(this);
      slideOfferTiers(this);
    }
  }
  customElements.define('free-shipping', FreeShipping);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.joyee-offer free-shipping').forEach(function (el) { giftTiers(el); slideOfferTiers(el); });
  });
}